import { useRef } from "react";
import { headerMenuLinks } from "../data";

type HeaderMenuLink = (typeof headerMenuLinks)[number];

const V_POS_OFFSET = 30;
const H_POS_OFFSET = 40;

type HeaderMenuItemImageProps = {
  hoveredLink: HeaderMenuLink | null;
};

export function HeaderMenuItemImage({ hoveredLink }: HeaderMenuItemImageProps) {
  const ref = useRef<HTMLImageElement>(null);

  if (!hoveredLink) return null;

  const isOdd = hoveredLink.index % 2 === 1;

  return (
    <img
      ref={ref}
      src={hoveredLink?.image}
      alt={hoveredLink?.label}
      className="animate-fade absolute hidden h-full lg:block"
      style={{
        top: isOdd
          ? `${hoveredLink.index * V_POS_OFFSET}px`
          : `${V_POS_OFFSET}px`,
        bottom: isOdd ? "auto" : `${hoveredLink.index * V_POS_OFFSET}px`,
        left: isOdd ? H_POS_OFFSET : "auto",
        right: isOdd ? "auto" : H_POS_OFFSET,
      }}
    />
  );
}
